import React from "react";
import { Link } from "react-router-dom";
import "../css/terms.scss";

function Terms() {
  return (
    <main>
      <div className="contained px-16">
        <nav aria-label="Breadcrumb">
          <ol className="text-grey-30 text-14 my-32 list-none font-semibold">
            <li className="inline-flex"><Link className="text-black" to="/">Home</Link></li>
            <li className="inline-flex">Terms &amp; Conditions</li>
          </ol>
        </nav>
        <h1 className="text-neutral mb-32 text-center font-light text-30">Terms &amp; Conditions</h1>
      </div>

      <div className="tablet:px-0 mb-32 px-16">
        <h2>ABOUT THESE TERMS</h2>
        <p>
          These terms apply when you use the Jskerandco website or buy from us.
          By placing an order, you confirm that you can enter into a binding
          agreement in your location. These terms were last updated on
          September 8, 2026.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16 bg-grey-4 py-32">
        <h2>PRODUCT INFORMATION</h2>
        <p>
          We aim to describe products, materials, colors, dimensions, and
          available options accurately. Screen settings and natural variation
          can affect appearance. Please review all selections, spelling, sizing,
          and delivery details before submitting an order. If a page contains a
          clear error, contact us before ordering.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16">
        <h2>PRICES AND ORDERS</h2>
        <p>
          The price, currency, shipping charge, and any applicable tax shown at
          checkout form part of your order. An on-screen or email acknowledgement
          means we received the request; acceptance occurs when we confirm the
          order for fulfillment. We may cancel and refund an order we cannot
          fulfill, including because of availability, pricing error, suspected
          misuse, or an unverifiable payment.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16 bg-grey-4 py-32">
        <h2>PERSONALIZED ITEMS</h2>
        <p>
          You are responsible for the text, dates, images, and other choices you
          submit. You confirm that your submission is lawful and that you have
          permission to use it. Production may begin soon after acceptance, so
          changes or cancellations may not be possible. Return eligibility for
          personalized goods may also be limited, except where the goods are
          faulty or applicable law provides otherwise.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16">
        <h2>SHIPPING, RETURNS, AND REFUNDS</h2>
        <p>
          Current delivery information appears on our <Link to="/shipping">Shipping Information</Link>
          {" "}page. To request return assistance, follow the instructions on our
          {" "}<Link to="/returns">Returns &amp; Order Help</Link> page. No site
          policy limits rights that cannot lawfully be excluded in your location.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16 bg-grey-4 py-32">
        <h2>ACCEPTABLE USE</h2>
        <p>
          You may not interfere with the site, attempt unauthorized access,
          introduce malicious code, scrape the site at disruptive scale, misuse
          checkout, impersonate another person, or use the service for unlawful
          or fraudulent activity. We may restrict access when reasonably needed
          to protect customers, the site, or third parties.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16">
        <h2>CONTENT AND INTELLECTUAL PROPERTY</h2>
        <p>
          Unless a different owner is identified, the original text, layout,
          and brand elements created for this site belong to Jskerandco or are
          used with permission. Product names may describe the items rather than
          indicate exclusive ownership. Third-party names and marks remain the
          property of their respective owners. You may not republish substantial
          site content without permission or another lawful basis.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16 bg-grey-4 py-32">
        <h2>LIABILITY</h2>
        <p>
          Nothing in these terms excludes liability that cannot legally be
          excluded. To the extent permitted by law, we are not responsible for
          indirect or unforeseeable loss, external services, or interruptions
          outside our reasonable control. Any other liability relating to an
          order is limited to the amount paid for that order, except where such
          a limit is prohibited.
        </p>
      </div>

      <div className="tablet:px-0 mb-32 px-16">
        <h2>CHANGES AND CONTACT</h2>
        <p>
          We may update these terms for future use of the site. The terms in
          effect when your order is accepted continue to govern that order.
          Questions may be sent to{" "}
          <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a>.
        </p>
      </div>
    </main>
  );
}

export default Terms;
